module.exports = __webpack_public_path__ + "img/tunai.974b6dd7.png";